module.exports = __webpack_public_path__ + "img/MoreFooter.3a65ed8d.svg";